// extracted by mini-css-extract-plugin
module.exports = {"top":"CommonBeginningQuestions_top__2JIrk"};